import apiService from '../Api'
import {
  JobPosition,
  JobPositionDetail,
  JobPositionFilters,
  JobPositionInput,
  JobPositionOption,
  JobPositionPage,
  JobPositionStatus
} from './types'

export class JobPositionService {
  /** The registry page, filtered and paginated. */
  async list(filters: JobPositionFilters): Promise<JobPositionPage> {
    return apiService.get('/job-position', { params: filters }).then((response) => response.data)
  }

  /** Every role, for role pickers and filters. */
  async listAll(): Promise<JobPosition[]> {
    return apiService.get('/job-position/all').then((response) => response.data)
  }

  /** Active roles with a complete registration, for public forms (no login needed), optionally from one sector. */
  async listForForms(sectorId?: number): Promise<JobPositionOption[]> {
    return apiService
      .get('/job-position/select', { params: sectorId ? { sector_id: sectorId } : undefined })
      .then((response) => response.data)
  }

  /** The role with its graduations and required documents. */
  async show(id: number): Promise<JobPositionDetail> {
    return apiService.get(`/job-position/${id}`).then((response) => response.data)
  }

  async create(jobPosition: JobPositionInput): Promise<JobPositionDetail> {
    return apiService.post('/job-position', jobPosition).then((response) => response.data)
  }

  async update(id: number, jobPosition: JobPositionInput): Promise<JobPositionDetail> {
    return apiService.put(`/job-position/${id}`, jobPosition).then((response) => response.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/job-position/${id}`)
  }

  async updateStatus(id: number, newStatus: JobPositionStatus): Promise<JobPosition> {
    return apiService.put(`/job-position/${id}/update-status`, { status: newStatus }).then((response) => response.data)
  }
}
